import { HTMLAttributes } from 'react';
import clsx from 'clsx';

type Color = 'gray' | 'green' | 'yellow' | 'red' | 'blue';

const colors: Record<Color, string> = {
  gray: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
  green: 'bg-success-500/10 text-success-600 dark:text-success-500',
  yellow: 'bg-warning-500/10 text-warning-500',
  red: 'bg-error-500/10 text-error-600 dark:text-error-500',
  blue: 'bg-brand-50 text-brand-600 dark:bg-brand-950 dark:text-brand-300',
};

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  color?: Color;
}

const Badge = ({ color = 'gray', className, ...props }: BadgeProps) => (
  <span
    className={clsx(
      'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
      colors[color],
      className
    )}
    {...props}
  />
);

export default Badge;
